module.exports = __webpack_public_path__ + "media/images/div_lens/racial-age50-9ec1155b8cf2db0cf4616b8e0d80a209.png";